/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from '@angular/forms';
import * as i2 from '../../../ui/settings/rendering.component';
import * as i3 from '@angular/common';
const styles_RenderingComponent:any[] = ([] as any[]);
export const RenderType_RenderingComponent:i0.RendererType2 = i0.ɵcrt({encapsulation:2,
    styles:styles_RenderingComponent,data:{}});
function View_RenderingComponent_1(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),3,'option',([] as any[]),
      (null as any),(null as any),(null as any),(null as any),(null as any))),i0.ɵdid(147456,
      (null as any),0,i1.NgSelectOption,[i0.ElementRef,i0.Renderer2,[2,i1.SelectControlValueAccessor]],
      {ngValue:[0,'ngValue']},(null as any)),i0.ɵdid(147456,(null as any),0,i1.ɵq,
      [i0.ElementRef,i0.Renderer2,[8,(null as any)]],{ngValue:[0,'ngValue']},(null as any)),
      (_l()(),i0.ɵted((null as any),['','']))],(_ck,_v) => {
    const currVal_0:any = _v.context.$implicit;
    _ck(_v,1,0,currVal_0);
    const currVal_1:any = _v.context.$implicit;
    _ck(_v,2,0,currVal_1);
  },(_ck,_v) => {
    const currVal_2:any = ((_v.context.$implicit == 0)? 'hidden': _v.context.$implicit);
    _ck(_v,3,0,currVal_2);
  });
}
export function View_RenderingComponent_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),48,'div',[['class',
      'settings-block']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵted((null as any),['\n	'])),(_l()(),i0.ɵeld(0,(null as any),(null as any),
          1,'h6',([] as any[]),(null as any),(null as any),(null as any),(null as any),
          (null as any))),(_l()(),i0.ɵted((null as any),['Rendering'])),(_l()(),i0.ɵted((null as any),
          ['\n\n	'])),(_l()(),i0.ɵeld(0,(null as any),(null as any),1,'div',[['class',
          'settings-left']],(null as any),(null as any),(null as any),(null as any),
          (null as any))),(_l()(),i0.ɵted((null as any),['\n		Average FPS:\n	'])),
      (_l()(),i0.ɵted((null as any),['\n	'])),(_l()(),i0.ɵeld(0,(null as any),(null as any),
          1,'div',[['class','settings-right']],(null as any),(null as any),(null as any),
          (null as any),(null as any))),(_l()(),i0.ɵted((null as any),['\n		','\n	'])),
      (_l()(),i0.ɵted((null as any),['\n	'])),(_l()(),i0.ɵeld(0,(null as any),(null as any),
          0,'br',([] as any[]),(null as any),(null as any),(null as any),(null as any),
          (null as any))),(_l()(),i0.ɵted((null as any),['\n\n	'])),(_l()(),i0.ɵeld(0,
          (null as any),(null as any),1,'div',[['class','settings-left middle']],(null as any),
          (null as any),(null as any),(null as any),(null as any))),(_l()(),i0.ɵted((null as any),
          ['\n		Visualization smoothing length:\n	'])),(_l()(),i0.ɵted((null as any),
          ['\n	'])),(_l()(),i0.ɵeld(0,(null as any),(null as any),12,'div',[['class',
          'settings-right middle']],(null as any),(null as any),(null as any),(null as any),
          (null as any))),(_l()(),i0.ɵted((null as any),['\n		'])),(_l()(),i0.ɵeld(0,
          (null as any),(null as any),1,'div',[['style','display: inline-block; width: 70px;']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵted((null as any),['',''])),(_l()(),i0.ɵted((null as any),['\n		'])),
      (_l()(),i0.ɵeld(0,(null as any),(null as any),6,'input',[['class','slider'],
          ['max','0.1'],['min','0.001'],['step','0.001'],['title','visual smoothing length'],
          ['type','range']],[[2,'ng-untouched',(null as any)],[2,'ng-touched',(null as any)],
          [2,'ng-pristine',(null as any)],[2,'ng-dirty',(null as any)],[2,'ng-valid',
              (null as any)],[2,'ng-invalid',(null as any)],[2,'ng-pending',(null as any)]],
          [[(null as any),'ngModelChange'],[(null as any),'input'],[(null as any),
              'blur'],[(null as any),'compositionstart'],[(null as any),'compositionend'],
              [(null as any),'change']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:i2.RenderingComponent = _v.component;
            if (('input' === en)) {
              const pd_0:any = ((<any>i0.ɵnov(_v,22)._handleInput($event.target.value)) !== false);
              ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
              const pd_1:any = ((<any>i0.ɵnov(_v,22).onTouched()) !== false);
              ad = (pd_1 && ad);
            }
            if (('compositionstart' === en)) {
              const pd_2:any = ((<any>i0.ɵnov(_v,22)._compositionStart()) !== false);
              ad = (pd_2 && ad);
            }
            if (('compositionend' === en)) {
              const pd_3:any = ((<any>i0.ɵnov(_v,22)._compositionEnd($event.target.value)) !== false);
              ad = (pd_3 && ad);
            }
            if (('change' === en)) {
              const pd_4:any = ((<any>i0.ɵnov(_v,23).onChange($event.target.value)) !== false);
              ad = (pd_4 && ad);
            }
            if (('input' === en)) {
              const pd_5:any = ((<any>i0.ɵnov(_v,23).onChange($event.target.value)) !== false);
              ad = (pd_5 && ad);
            }
            if (('blur' === en)) {
              const pd_6:any = ((<any>i0.ɵnov(_v,23).onTouched()) !== false);
              ad = (pd_6 && ad);
            }
            if (('ngModelChange' === en)) {
              const pd_7:any = ((<any>(_co.visuSmoothingLength = $event)) !== false);
              ad = (pd_7 && ad);
            }
            return ad;
          },(null as any),(null as any))),i0.ɵdid(16384,(null as any),0,i1.DefaultValueAccessor,
          [i0.Renderer2,i0.ElementRef,[2,i1.COMPOSITION_BUFFER_MODE]],(null as any),
          (null as any)),i0.ɵdid(16384,(null as any),0,i1.ɵbe,[i0.Renderer2,i0.ElementRef],
          (null as any),(null as any)),i0.ɵprd(1024,(null as any),i1.NG_VALUE_ACCESSOR,
          (p0_0:any,p1_0:any) => {
            return [p0_0,p1_0];
          },[i1.DefaultValueAccessor,i1.ɵbe]),i0.ɵdid(671744,(null as any),0,i1.NgModel,
          [[8,(null as any)],[8,(null as any)],[8,(null as any)],[2,i1.NG_VALUE_ACCESSOR]],
          {model:[0,'model']},{update:'ngModelChange'}),i0.ɵprd(2048,(null as any),
          i1.NgControl,(null as any),[i1.NgModel]),i0.ɵdid(16384,(null as any),0,i1.NgControlStatus,
          [i1.NgControl],(null as any),(null as any)),(_l()(),i0.ɵted((null as any),
          ['\n\n	'])),(_l()(),i0.ɵted((null as any),['\n	'])),(_l()(),i0.ɵeld(0,(null as any),
          (null as any),0,'br',([] as any[]),(null as any),(null as any),(null as any),
          (null as any),(null as any))),(_l()(),i0.ɵted((null as any),['\n\n	'])),
      (_l()(),i0.ɵeld(0,(null as any),(null as any),1,'div',[['class','settings-left']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵted((null as any),['\n		Particle size:\n	'])),(_l()(),i0.ɵted((null as any),
          ['\n	'])),(_l()(),i0.ɵeld(0,(null as any),(null as any),12,'div',[['class',
          'settings-right']],(null as any),(null as any),(null as any),(null as any),
          (null as any))),(_l()(),i0.ɵted((null as any),['\n		'])),(_l()(),i0.ɵeld(0,
          (null as any),(null as any),9,'select',[['class','select'],['title','visual particle size']],
          [[2,'ng-untouched',(null as any)],[2,'ng-touched',(null as any)],[2,'ng-pristine',
              (null as any)],[2,'ng-dirty',(null as any)],[2,'ng-valid',(null as any)],
              [2,'ng-invalid',(null as any)],[2,'ng-pending',(null as any)]],[[(null as any),
              'ngModelChange'],[(null as any),'change'],[(null as any),'blur']],(_v,
              en,$event) => {
            var ad:boolean = true;
            var _co:i2.RenderingComponent = _v.component;
            if (('change' === en)) {
              const pd_0:any = ((<any>i0.ɵnov(_v,38).onChange($event.target.value)) !== false);
              ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
              const pd_1:any = ((<any>i0.ɵnov(_v,38).onTouched()) !== false);
              ad = (pd_1 && ad);
            }
            if (('ngModelChange' === en)) {
              const pd_2:any = ((<any>(_co.pSize = $event)) !== false);
              ad = (pd_2 && ad);
            }
            return ad;
          },(null as any),(null as any))),i0.ɵdid(16384,(null as any),0,i1.SelectControlValueAccessor,
          [i0.Renderer2,i0.ElementRef],(null as any),(null as any)),i0.ɵprd(1024,(null as any),
          i1.NG_VALUE_ACCESSOR,(p0_0:any) => {
            return [p0_0];
          },[i1.SelectControlValueAccessor]),i0.ɵdid(671744,(null as any),0,i1.NgModel,
          [[8,(null as any)],[8,(null as any)],[8,(null as any)],[2,i1.NG_VALUE_ACCESSOR]],
          {model:[0,'model']},{update:'ngModelChange'}),i0.ɵprd(2048,(null as any),
          i1.NgControl,(null as any),[i1.NgModel]),i0.ɵdid(16384,(null as any),0,i1.NgControlStatus,
          [i1.NgControl],(null as any),(null as any)),(_l()(),i0.ɵted((null as any),
          ['\n			'])),(_l()(),i0.ɵand(16777216,(null as any),(null as any),1,(null as any),
          View_RenderingComponent_1)),i0.ɵdid(802816,(null as any),0,i3.NgForOf,[i0.ViewContainerRef,
          i0.TemplateRef,i0.IterableDiffers],{ngForOf:[0,'ngForOf']},(null as any)),
      (_l()(),i0.ɵted((null as any),['\n		'])),(_l()(),i0.ɵted((null as any),['\n	'])),
      (_l()(),i0.ɵted((null as any),['\n'])),(_l()(),i0.ɵted((null as any),['\n']))],
      (_ck,_v) => {
        var _co:i2.RenderingComponent = _v.component;
        const currVal_9:any = _co.visuSmoothingLength;
        _ck(_v,25,0,currVal_9);
        const currVal_17:any = _co.pSize;
        _ck(_v,40,0,currVal_17);
        const currVal_18:any = _co.sizes;
        _ck(_v,45,0,currVal_18);
      },(_ck,_v) => {
        var _co:i2.RenderingComponent = _v.component;
        const currVal_0:any = _co.fps.toFixed(2);
        _ck(_v,9,0,currVal_0);
        const currVal_1:any = _co.visuSmoothingLength;
        _ck(_v,19,0,currVal_1);
        const currVal_2:any = i0.ɵnov(_v,27).ngClassUntouched;
        const currVal_3:any = i0.ɵnov(_v,27).ngClassTouched;
        const currVal_4:any = i0.ɵnov(_v,27).ngClassPristine;
        const currVal_5:any = i0.ɵnov(_v,27).ngClassDirty;
        const currVal_6:any = i0.ɵnov(_v,27).ngClassValid;
        const currVal_7:any = i0.ɵnov(_v,27).ngClassInvalid;
        const currVal_8:any = i0.ɵnov(_v,27).ngClassPending;
        _ck(_v,21,0,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,currVal_7,currVal_8);
        const currVal_10:any = i0.ɵnov(_v,42).ngClassUntouched;
        const currVal_11:any = i0.ɵnov(_v,42).ngClassTouched;
        const currVal_12:any = i0.ɵnov(_v,42).ngClassPristine;
        const currVal_13:any = i0.ɵnov(_v,42).ngClassDirty;
        const currVal_14:any = i0.ɵnov(_v,42).ngClassValid;
        const currVal_15:any = i0.ɵnov(_v,42).ngClassInvalid;
        const currVal_16:any = i0.ɵnov(_v,42).ngClassPending;
        _ck(_v,37,0,currVal_10,currVal_11,currVal_12,currVal_13,currVal_14,currVal_15,
            currVal_16);
      });
}
export function View_RenderingComponent_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),1,'websph-settings-rendering',
      ([] as any[]),(null as any),(null as any),(null as any),View_RenderingComponent_0,
      RenderType_RenderingComponent)),i0.ɵdid(49152,(null as any),0,i2.RenderingComponent,
      ([] as any[]),(null as any),(null as any))],(null as any),(null as any));
}
export const RenderingComponentNgFactory:i0.ComponentFactory<i2.RenderingComponent> = i0.ɵccf('websph-settings-rendering',
    i2.RenderingComponent,View_RenderingComponent_Host_0,{},{visuSmoothingLengthNotify:'visuSmoothingLengthNotify',
        pSizeNotify:'pSizeNotify'},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// D:/[Projects]/WebSPH.gits/WebSPH.git/src/$$_gendir/ui/settings/rendering.component.ngfactory.ts